import React from "react";
import "./terms.css"

import logoWhite from './logo_white.png';

const TermsAndConditions = () => {
  return (
    <div style={{ backgroundColor: "#fff", color: "#000" }}>

      <nav className="navbar navbar-expand-lg navbar-dark bg-dark sticky-top px-3">
        <div className="container-fluid">
          <a className="navbar-brand" href="/">
            <img
              src={logoWhite}
              alt="KeyConnect Logo"
              style={{ height: "40px", marginLeft: "20px" }}
            />
          </a>


        </div>
      </nav>

      <section className="legal-page">
        <div className="wrap">
          <h1>Terms and Conditions</h1>

          <div className="legal-meta">
            <div>
              <strong>Effective Date:</strong> 8<sup>th</sup> July 2025
            </div>
            <div>
              <strong>Website:</strong>{" "}
              <a
                href="https://www.keyconnect.in"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://www.keyconnect.in
              </a>
            </div>
            <div>
              <strong>Platform:</strong> KeyConnect CRM
            </div>
          </div>

          <p>
            By accessing or using the website and platform of{" "}
            <strong>KeyConnect CRM</strong> ("KeyConnect", "we", "our", or
            "us"), you ("User", "you", or "Client") agree to comply with and
            be bound by the following Terms and Conditions. If you do not
            agree with these terms, please do not access or use the
            platform.
          </p>

          <section>
            <h2>1. Acceptance of Terms</h2>
            <p>
              These Terms govern your use of the KeyConnect CRM platform and
              related services. By registering for an account, accessing the
              platform, or subscribing to services, you agree to be bound by
              this agreement.
            </p>
          </section>

          <section>
            <h2>2. Platform Overview</h2>
            <p>
              KeyConnect CRM is a cloud-based lead management solution
              offered to businesses for managing leads, clients, and
              communications. The platform may also include integrations
              with third-party tools such as WhatsApp, SMS, IVR, and other
              APIs.
            </p>
          </section>

          <section>
            <h2>3. Eligibility</h2>
            <p>
              You must be at least 18 years of age and legally capable of
              entering into contracts to use this platform. If you use the
              platform on behalf of an organization, you represent that you
              have the authority to bind the organization.
            </p>
          </section>

          <section>
            <h2>4. Account Registration</h2>
            <ul>
              <li>
                You agree to provide accurate and complete information when
                creating your account.
              </li>
              <li>
                You are responsible for maintaining the confidentiality of
                your credentials.
              </li>
              <li>
                You agree not to share access credentials or allow
                unauthorized access.
              </li>
              <li>
                You must notify us immediately of any unauthorized use of
                your account.
              </li>
            </ul>
          </section>

          <section>
            <h2>5. Use of Services</h2>
            <p>You agree to use the platform:</p>
            <ul>
              <li>Only for lawful business purposes</li>
              <li>Without violating applicable laws or infringing rights</li>
              <li>
                Without attempting to reverse engineer, modify, or exploit
                the platform outside its intended use
              </li>
            </ul>
          </section>

          <section>
            <h2>6. Subscription &amp; Payments</h2>
            <ul>
              <li>
                Access to KeyConnect CRM requires a paid subscription based
                on the plan chosen.
              </li>
              <li>
                Payment obligations, billing cycles, and plan terms are
                governed by your Service Level Agreement (SLA).
              </li>
              <li>
                Failure to pay may result in account suspension or
                termination.
              </li>
            </ul>
          </section>

          <section>
            <h2>7. Third-Party Services</h2>
            <p>
              KeyConnect integrates services from third parties (e.g., SMS
              providers, WhatsApp API, Meta, IVR).
            </p>
            <ul>
              <li>
                We are not liable for the functionality, availability, or
                pricing of any third-party services.
              </li>
              <li>
                The client is responsible for maintaining valid accounts and
                complying with third-party terms.
              </li>
            </ul>
          </section>

          <section>
            <h2>8. Intellectual Property</h2>
            <ul>
              <li>
                All content, code, features, and trademarks associated with
                KeyConnect CRM are owned by HACHI SERVICES or licensed to us.
              </li>
              <li>
                You are granted a non-exclusive, non-transferable right to
                use the platform per your subscription.
              </li>
              <li>
                You shall not copy, resell, or commercially exploit the
                platform outside your licensed usage.
              </li>
            </ul>
          </section>

          <section>
            <h2>9. Data &amp; Privacy</h2>
            <ul>
              <li>
                You retain ownership of your data submitted to the platform.
              </li>
              <li>
                We may process your data only as outlined in our{" "}
                <a
                  href="/privacy-policy"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Privacy Policy
                </a>
                .
              </li>
              <li>
                You agree not to misuse, harvest, or expose user or customer
                data hosted on the platform.
              </li>
            </ul>
          </section>

          <section>
            <h2>10. Termination</h2>
            <p>We reserve the right to suspend or terminate your access:</p>
            <ul>
              <li>For breach of these Terms</li>
              <li>For prolonged non-payment</li>
              <li>If required by law or for system integrity</li>
            </ul>
            <p>
              You may also terminate your account at any time by written
              notice. Data will be retained for a limited post-termination
              period as defined in our SLA.
            </p>
          </section>

          <section>
            <h2>11. Disclaimers</h2>
            <ul>
              <li>
                The platform is provided on an "as is" and "as available"
                basis.
              </li>
              <li>
                We do not guarantee uninterrupted service or error-free
                performance.
              </li>
              <li>
                We are not liable for damages caused by service
                interruptions, data loss, or integration failures.
              </li>
            </ul>
          </section>

          <section>
            <h2>12. Limitation of Liability</h2>
            <p>
              To the fullest extent permitted by law, KeyConnect CRM and its
              affiliates shall not be liable for indirect, incidental, or
              consequential damages. Total liability shall not exceed the
              amount paid by the user in the last 3 months.
            </p>
          </section>

          <section>
            <h2>13. Indemnity</h2>
            <p>
              You agree to indemnify and hold harmless KeyConnect CRM, its
              partners, directors, and staff from any third-party claims or
              damages resulting from:
            </p>
            <ul>
              <li>Violation of these Terms</li>
              <li>Misuse of the platform</li>
              <li>Violation of applicable laws or third-party rights</li>
            </ul>
          </section>

          <section>
            <h2>14. Changes to Terms</h2>
            <p>
              We reserve the right to modify these Terms at any time. Changes
              will be effective upon posting on this page. Continued use of
              the platform after changes constitutes your acceptance of the
              revised terms.
            </p>
          </section>

          <section>
            <h2>15. Governing Law &amp; Jurisdiction</h2>
            <p>
              These Terms are governed by the laws of{" "}
              <strong>Bangalore, India</strong>. Any disputes arising out of
              or in connection with these Terms shall be subject to the
              exclusive jurisdiction of the courts located at{" "}
              <strong>Bangalore, India</strong>.
            </p>
          </section>

          <section>
            <h2>16. Contact Information</h2>
            <p>
              <strong>KeyConnect CRM</strong>
              <br />
              Email:{" "}
              <a href="mailto:support@keyconnect.in">support@keyconnect.in</a>
              <br />
              Website:{" "}
              <a
                href="https://www.keyconnect.in"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://www.keyconnect.in
              </a>
            </p>
          </section>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-dark text-light text-center py-4">
        <small>
          &copy; {new Date().getFullYear()} KeyConnect CRM. All rights reserved.
        </small>
      </footer>
    </div>
  );
};

export default TermsAndConditions;